import React, { createContext, useContext } from 'react';

const CashbackSelectionsContext = createContext();

/**
 * CashbackSelectionsProvider is now a no-op shell.
 * Co-branding cashback tracking has been removed.
 */
export function CashbackSelectionsProvider({ children }) {
  return (
    <CashbackSelectionsContext.Provider value={{ selections: {}, updateSelections: () => {} }}>
      {children}
    </CashbackSelectionsContext.Provider>
  );
}

export function useCashbackSelections() {
  const ctx = useContext(CashbackSelectionsContext);
  if (!ctx) throw new Error('useCashbackSelections must be used within CashbackSelectionsProvider');
  return ctx;
}